import FactorGraphContainer from './factor_graph_container';

const FactorGraph = FactorGraphContainer;
export default FactorGraph;
